import { Injectable } from '@angular/core';
import { map, shareReplay, timer } from 'rxjs';

/**
 * Shared clock that emits the current time every second.
 *
 * Use this when components need to react to elapsed time (e.g. REI badges, countdowns)
 * without each component starting its own interval. A single interval is shared;
 * it runs only while at least one subscriber exists (refCount) and stops when
 * the last subscriber unsubscribes.
 *
 * Emits immediately on subscribe, then every 1000ms.
 */
@Injectable({ providedIn: 'root' })
export class ClockService {
	/** Emits current timestamp (ms) every second, plus once on subscribe. */
	readonly tick$ = timer(0, 1000).pipe(
		map(() => Date.now()),
		shareReplay({ bufferSize: 1, refCount: true }),
	);
}
